import { 
    PROVIDER_TYPE, CONSUMER_TYPE, PAYER_TYPE, DEVELOPER_TYPE
} 
from "./Constants";

export default class UserManager {

    static instance = null
    static getInstance() {
        if (UserManager.instance === null) {
            UserManager.instance = new UserManager();
        }
        return UserManager.instance;
    }
    static reset() {
        UserManager.instance = null;
    }
    constructor() {
        this.readUserFromSession();
    }

    readUserFromSession = () => {
        let userObj = JSON.parse(localStorage.getItem('myElthSessionUser'));
        let devObj = (JSON.parse(localStorage.getItem('myElthDeveloper')));
        if (userObj) {
            this.setUserType(userObj.userType);
            this.setUserID(userObj.userID);
            this.setFirstName(userObj.firstName);
            this.setLastName(userObj.lastName);
            this.setSpeciality(userObj.speciality);
            if (userObj.hospitalArray) {
                this.setHospitalArray(userObj.hospitalArray);
            }
        }
        if (devObj) {
            this.setUserType('developer');
            this.setUserID(devObj.userId);
            this.setFirstName(devObj.firstName);
            this.setLastName(devObj.lastName);
        }
    }

    setHospitalArray(hospitalArray) {
        this.hospitalArray = hospitalArray;
    }

    getHospitalArray() {
        return this.hospitalArray;
    }

    setUserType = (userType) => {
        this.userType = userType;
    }

    setUserID = (userID) => {
        this.userID = userID;
    }
    getUserID = () => {
        return this.userID;
    }

    setFirstName = (firstName) => {
        this.firstName = firstName;
    }
    getFirstName = () => {
        return this.firstName;
    }
    setLastName = (lastName) => {
        this.lastName = lastName;
    }
    getLastName = () => {
        return this.lastName;
    }
    setSpeciality = (speciality) => {
        this.speciality = speciality;
    }
    getSpeciality = () => {
        return this.speciality;
    }

    isProvider = () => {
        return this.userType === PROVIDER_TYPE;
    }   

    isConsumer = () => {
        return this.userType === CONSUMER_TYPE;
    }   

    isPayer = () => {
        return this.userType === PAYER_TYPE;
    }
    isDeveloper = () => {
        return this.userType === DEVELOPER_TYPE;
    }
}